import { render } from "./PackageOrderImportAssistant.vue?vue&type=template&id=256eabab"
import script from "./PackageOrderImportAssistant.vue?vue&type=script&lang=js"
export * from "./PackageOrderImportAssistant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__